/**
 * Modal 场景 webp letterbox / 加载前兜底色。
 * 与 Plan Gate 解耦后仍供 `DiagnosisUnlockSceneBackground` 使用。
 */
export const PLAN_GATE_MODAL_SCENE_FALLBACK_CLASS =
  "bg-background_white_overlay100";
